<script lang="ts">
  import { Button } from "sveltestrap";
  import { AddTask, Addnewtask, Close } from "../../../utils/Constant/Constant";
  import {allTodoList} from "../../../store"
  let isTodo:boolean = false;
  let todoData:string = '';
  const handleClick = () => {
    isTodo = !isTodo;
  };
  let setAlltodoList
  allTodoList.subscribe((value) => {
    setAlltodoList = value
  })
  const addTodo = (data:string) => {
    if (todoData !== '') {
      allTodoList.update(value => value  = [...setAlltodoList, data])
      todoData = '';
      isTodo = !isTodo;
    }
  };

</script>
<div class="todo-list-footer">
  <div class="add-task-btn-wrapper">
    <span class="add-task-btn {isTodo ? 'hide' : ''}">
      <Button color="primary" on:click={handleClick}>
        <i class="icon-plus"></i> {Addnewtask}
      </Button>
    </span>
  </div>
  <div class="new-task-wrapper {isTodo ? 'visible' : ''}">
    <textarea id="new-task" placeholder="Enter new task here. . ." bind:value={todoData}></textarea>
    <!-- svelte-ignore a11y-click-events-have-key-events -->
    <Button color="danger" class="cancel-btn" id="close-task-panel" on:click={handleClick}>{Close}</Button>
    <!-- svelte-ignore a11y-click-events-have-key-events -->
    <Button color="success" class="ms-3 add-new-task-btn" id="add-task" on:click={() => addTodo(todoData)}>{AddTask}</Button>
  </div>
</div>